 
//------------------------------------------------------------
// 
// Author:    Tony Henderson
// Generator: BinaryBlox Automated Tool Chain  #}
// Project:   https://github.com/BinaryBlox-Schedule-API
//------------------------------------------------------------


import { Configuration } from "./configuration";

/**
 * The Singleton class defines the `getInstance` method that lets clients access
 * the unique singleton instance.
 */
export class ApiManager {
  private static instance: ApiManager;

  private _configuration: Configuration | undefined;

  /**
   * The Singleton's constructor should always be private to prevent direct
   * construction calls with the `new` operator.
   */
  private constructor() {
    // this._configuration = new Configuration();
  }

  /**
   * The static method that controls the access to the singleton instance.
   *
   * This implementation let you subclass the Singleton class while keeping
   * just one instance of each subclass around.
   */
  public static getInstance(): ApiManager {
    if (!ApiManager.instance) {
      ApiManager.instance = new ApiManager();
    }

    return ApiManager.instance;
  }

  /**
   * 
   * @param configuration 
   */ 
  public setConfiguration(configuration: Configuration) {
    this._configuration = configuration;
  }

  /**
   * 
   * @returns 
   */
  public getConfiguration() {
    return this._configuration;
  } 

}
